import ClickAwayListener from "react-click-away-listener";
import styled from "styled-components";
import React, { useEffect, useState, useRef } from "react";
import { Icon } from "semantic-ui-react";
import { usePageTranslations } from "hooks/usePageTranslations";

const Dropdown = ({ options, setSelected, label, selectedOption }) => {
  const t = usePageTranslations('app/audit/simple/QuestionDropdown/translations');
  
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const [selected, setSelectedOption] = useState(null);
  const [showShadow, setShowShadow] = useState(true);
  const dropdownRef = useRef(null);

  const selectOption = (option) => {
    setOpen(false);
    setSelected(option?.value);
    setSelectedOption(option);
  };

  useEffect(() => {
    if (selectedOption) {
      setSelectedOption(
        options.find((option) => option.value === selectedOption)
      );
    } else {
      setSelectedOption(null);
    }
  }, [selectedOption, options]);

  const handleScroll = () => {
    if (dropdownRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;
      setShowShadow(scrollTop + clientHeight < scrollHeight);
    }
  };



  return (
    <Box>
      <Label>{label}</Label>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <DropdownContainer
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Nav onClick={() => setOpen(!open)}>
            <Selection>{selected?.name || t('selectAnOption')}</Selection>
            <Icon
              name="chevron down"
              style={{ color: "#9ca3af", fontSize: "14px" }}
            />
          </Nav>
          {open && (
            <DropdownContent ref={dropdownRef}>
              {options.map((option, i) => (
                <Option key={i} onClick={() => selectOption(option)}>
                  {option.name}
                </Option>
              ))}
            </DropdownContent>
          )}
        </DropdownContainer>
      </ClickAwayListener>
    </Box>
  );
};

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

const DropdownContainer = styled.div`
  position: relative;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  width: 100%;
  max-width: 100%;
  background: white;
  transition: all 0.2s ease;
  min-width: 0;
  box-sizing: border-box;
  
  &:hover {
    border-color: #d1d5db;
  }
  
  &:focus-within {
    border-color: #2d70e2;
    box-shadow: 0 0 0 3px rgba(45, 112, 226, 0.1);
  }
`;

const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

const Selection = styled.div`
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  margin-right: 8px;
  min-width: 0; /* Allows flex item to shrink below content size */
`;

const DropdownContent = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
`;

const Option = styled.div`
  padding: 12px 16px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  &:hover {
    background-color: #f9fafb;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export default Dropdown;